import React, { Component } from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';

import { ROUTES } from '.';
import { Main, Auth } from '../wrappers';

export default class Router extends Component {

    build = (r) => {

        if (!r.props) {
            r.props = {};
        }

        return (
            <Route
                key={r.path}
                exact={r.exact}
                path={r.path}
                render={(props) => {
                    if (r.authenticated) {
                        return (
                            <Auth>
                                <r.screen key={r.path} {...this.props} {...props} {...r.props} />
                            </Auth>
                        );
                    }
                    return (
                        <r.screen key={r.path} {...this.props} {...props} {...r.props} />
                    );
                }}
            />
        );
    }

    render() {
        return (
            <BrowserRouter>
                <Main {...this.props}>
                    <Switch>
                        {ROUTES.map(this.build)}
                    </Switch>
                </Main>
            </BrowserRouter>
        );
    }
}
